<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 182 141"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>diy-home-renovators</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-53.000000, -667.000000)">
        <g
          id="diy-home-renovators"
          transform="translate(54.000000, 667.000000)">
          <g id="Background">
            <g id="New_Symbol_68-3">
              <path
                id="Path"
                d="M173.793137,82.7586207 C173.789938,48.9612634 153.235897,18.5617393 121.872585,5.96792915 C90.5092735,-6.62588101 54.6393699,1.11683759 31.263446,25.5264168 C7.88752222,49.935996 1.70313471,86.1071589 15.6413793,116.896552 L166.427586,116.896552 C171.292267,106.173738 173.803774,94.5333283 173.793137,82.7586207 Z"
                class="fill-extra-light"
                fill-rule="nonzero" />
              <line
                id="Path"
                x1="9.31034483"
                y1="116.896552"
                x2="170.689655"
                y2="116.896552"
                class="stroke"
                stroke-width="2.06896552"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="0"
                y1="116.896552"
                x2="5.17241379"
                y2="116.896552"
                class="stroke"
                stroke-width="2.06896552"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="174.827586"
                y1="116.896552"
                x2="180"
                y2="116.896552"
                class="stroke"
                stroke-width="2.06896552"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
          <g
            id="Scene"
            transform="translate(19.620690, 6.206897)">
            <path
              id="Path"
              d="M120.82069,121.862069 C120.241379,121.737931 109.710345,119.793103 109.151724,119.668966 C101.817177,117.246182 96.8684523,110.386398 96.8827277,102.662069 L96.8827277,95.8551724 C96.8827277,93.112793 99.1058964,90.8896552 101.848276,90.8896552 C104.590655,90.8896552 106.813793,93.112793 106.813793,95.8551724 L106.813793,102.662069 C106.826734,106.02314 108.932184,109.020311 112.089655,110.172414 L122.62069,112.075862 C125.323076,112.572918 127.110849,115.166579 126.613793,117.868966 C126.116737,120.571352 123.523076,122.359125 120.82069,121.862069 L120.82069,121.862069 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="57.1586207"
              y1="99.5586207"
              x2="57.1586207"
              y2="91.7172414"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="96.8827586"
              y1="99.5586207"
              x2="96.8827586"
              y2="91.7172414"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="47.2275862"
              y="99.5586207"
              width="9.93103448"
              height="11.1724138" />
            <path
              id="Path"
              d="M109.296552,95.0068966 L109.296552,97.4896552 C109.296552,98.6323133 108.370244,99.5586207 107.227586,99.5586207 L96.8827586,99.5586207 L96.8827586,110.731034 L57.1586207,110.731034 L57.1586207,99.5586207 L46.8137931,99.5586207 C45.671135,99.5586207 44.7448276,98.6323133 44.7448276,97.4896552 L44.7448276,95.0068966 C44.7448276,77.1814301 59.1952232,62.7310345 77.0206897,62.7310345 C94.8461561,62.7310345 109.296552,77.1814301 109.296552,95.0068966 L109.296552,95.0068966 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M109.296552,95.0068966 L109.296552,97.4896552 C109.296552,98.6323133 108.370244,99.5586207 107.227586,99.5586207 L96.8827586,99.5586207 L96.8827586,110.731034 L57.1586207,110.731034 L57.1586207,99.5586207 L46.8137931,99.5586207 C45.671135,99.5586207 44.7448276,98.6323133 44.7448276,97.4896552 L44.7448276,95.0068966 C44.7448276,77.1814301 59.1952232,62.7310345 77.0206897,62.7310345 C94.8461561,62.7310345 109.296552,77.1814301 109.296552,95.0068966 L109.296552,95.0068966 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="96.8827586"
              y1="93.0206897"
              x2="96.8827586"
              y2="91.7793103"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M84.4689655,67.4689655 C84.4827658,67.9377912 84.3368602,68.3973938 84.0551724,68.7724138 C82.3840262,70.9631703 79.786419,72.2487652 77.0310345,72.2487652 C74.27565,72.2487652 71.6780427,70.9631703 70.0068966,68.7724138 C69.7178201,68.4001083 69.5645359,67.9402558 69.5724138,67.4689655 L69.5724138,57.1241379 L84.4689655,57.1241379 L84.4689655,67.4689655 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M84.4689655,67.4689655 C84.4827658,67.9377912 84.3368602,68.3973938 84.0551724,68.7724138 C82.3840262,70.9631703 79.786419,72.2487652 77.0310345,72.2487652 C74.27565,72.2487652 71.6780427,70.9631703 70.0068966,68.7724138 C69.7178201,68.4001083 69.5645359,67.9402558 69.5724138,67.4689655 L69.5724138,57.1241379 L84.4689655,57.1241379 L84.4689655,67.4689655 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M89.4344828,65.2137931 L89.4344828,75.9724138 C89.4344828,77.9478194 88.6497559,79.8423175 87.2529333,81.2391402 C85.8561106,82.6359628 83.9616125,83.4206897 81.9862069,83.4206897 L72.0551724,83.4206897 C67.9416032,83.4206897 64.6068966,80.085983 64.6068966,75.9724138 L64.6068966,65.1931034 C61.9485885,66.3256015 59.445624,67.7926168 57.1586207,69.5586207 L57.1586207,110.731034 L96.8827586,110.731034 L96.8827586,69.5586207 C94.60593,67.7830988 92.1007335,66.3217342 89.4344828,65.2137931 L89.4344828,65.2137931 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M89.4344828,65.2137931 L89.4344828,75.9724138 C89.4344828,77.9478194 88.6497559,79.8423175 87.2529333,81.2391402 C85.8561106,82.6359628 83.9616125,83.4206897 81.9862069,83.4206897 L72.0551724,83.4206897 C67.9416032,83.4206897 64.6068966,80.085983 64.6068966,75.9724138 L64.6068966,65.1931034 C61.9485885,66.3256015 59.445624,67.7926168 57.1586207,69.5586207 L57.1586207,110.731034 L96.8827586,110.731034 L96.8827586,69.5586207 C94.60593,67.7830988 92.1007335,66.3217342 89.4344828,65.2137931 L89.4344828,65.2137931 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M122.951724,130.179369 L122.951724,130.179369 C120.89494,130.179369 119.227586,128.511957 119.227586,126.455172 L119.227586,101.213793 C119.227586,100.071135 120.153894,99.1448276 121.296552,99.1448276 L124.606897,99.1448276 C125.749555,99.1448276 126.67592,100.071135 126.67592,101.213793 L126.67592,126.455172 C126.681405,127.444564 126.290822,128.395037 125.591205,129.094654 C124.891589,129.79427 123.941116,130.184853 122.951724,130.179369 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M132.075862,120.951724 C131.764303,122.006286 130.796174,122.730278 129.696552,122.731034 L123.944828,122.731034 C120.653972,122.731034 117.986207,120.063269 117.986207,116.772414 L117.986207,113.793103 C117.986207,110.502248 120.653972,107.834483 123.944828,107.834483 L129.696552,107.834483 C130.801923,107.837923 131.771889,108.571723 132.075862,109.634483 C133.172156,113.327249 133.172156,117.258958 132.075862,120.951724 L132.075862,120.951724 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M132.075862,120.951724 C131.764303,122.006286 130.796174,122.730278 129.696552,122.731034 L123.944828,122.731034 C120.653972,122.731034 117.986207,120.063269 117.986207,116.772414 L117.986207,113.793103 C117.986207,110.502248 120.653972,107.834483 123.944828,107.834483 L129.696552,107.834483 C130.801923,107.837923 131.771889,108.571723 132.075862,109.634483 C133.172156,113.327249 133.172156,117.258958 132.075862,120.951724 L132.075862,120.951724 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M122.951724,99.1448276 L122.951724,90.0413793 C122.951724,88.8987212 123.878032,87.9724138 125.02069,87.9724138 L136.606897,87.9724138 C137.925521,87.9779427 139.191734,87.4565671 140.124151,86.5241508 C141.056567,85.5917345 141.577943,84.3255208 141.572457,83.0068966 L141.572457,81.7655172 C141.572457,79.0231378 139.349276,76.8 136.606897,76.8 L135.365517,76.8"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M103.917241,70.5931034 L133.296552,70.5931034 C134.43921,70.5931034 135.365517,71.5194109 135.365517,72.662069 L135.365517,80.937931 C135.365517,82.0805891 134.43921,83.0068966 133.296552,83.0068966 L101.848276,83.0068966 L101.848276,72.662069 C101.848276,71.5194109 102.774583,70.5931034 103.917241,70.5931034 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M126.675862,83.0068966 C128.047052,83.0068966 129.158621,81.8953277 129.158621,80.5241379 C129.158621,79.1529482 128.047052,78.0413793 126.675862,78.0413793 L118.606897,78.0413793 C118.113045,78.0413793 117.639421,77.8451976 117.290215,77.4959919 C116.941009,77.1467863 116.744828,76.6731617 116.744828,76.1793103 C116.744828,75.1509181 115.911151,74.3172414 114.882759,74.3172414 L106.813793,74.3172414 C104.076123,74.3285776 101.859612,76.5450886 101.848276,79.2827586 L101.848276,84.8275862 C101.848276,85.8559785 102.681953,86.6896552 103.710345,86.6896552 C104.738737,86.6896552 105.572414,87.5233318 105.572414,88.5517241 L105.572414,92.8965517 C105.572414,94.2677414 106.683983,95.3793103 108.055172,95.3793103 C109.426362,95.3793103 110.537931,94.2677414 110.537931,92.8965517 L110.537931,91.6551724 C110.537931,90.9967039 110.799507,90.3652045 111.265114,89.899597 C111.730722,89.4339894 112.362221,89.1724138 113.02069,89.1724138 C113.68085,89.1779851 114.315592,88.9181989 114.782413,88.4513782 C115.249233,87.9845574 115.50902,87.3498159 115.503448,86.6896552 C115.514755,84.6375721 117.175503,82.9768237 119.227586,82.9655172 L126.675862,83.0068966 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M126.675862,83.0068966 C128.047052,83.0068966 129.158621,81.8953277 129.158621,80.5241379 C129.158621,79.1529482 128.047052,78.0413793 126.675862,78.0413793 L118.606897,78.0413793 C118.113045,78.0413793 117.639421,77.8451976 117.290215,77.4959919 C116.941009,77.1467863 116.744828,76.6731617 116.744828,76.1793103 C116.744828,75.1509181 115.911151,74.3172414 114.882759,74.3172414 L106.813793,74.3172414 C104.076123,74.3285776 101.859612,76.5450886 101.848276,79.2827586 L101.848276,84.8275862 C101.848276,85.8559785 102.681953,86.6896552 103.710345,86.6896552 C104.738737,86.6896552 105.572414,87.5233318 105.572414,88.5517241 L105.572414,92.8965517 C105.572414,94.2677414 106.683983,95.3793103 108.055172,95.3793103 C109.426362,95.3793103 110.537931,94.2677414 110.537931,92.8965517 L110.537931,91.6551724 C110.537931,90.9967039 110.799507,90.3652045 111.265114,89.899597 C111.730722,89.4339894 112.362221,89.1724138 113.02069,89.1724138 C113.68085,89.1779851 114.315592,88.9181989 114.782413,88.4513782 C115.249233,87.9845574 115.50902,87.3498159 115.503448,86.6896552 C115.514755,84.6375721 117.175503,82.9768237 119.227586,82.9655172 L126.675862,83.0068966 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M65.4344828,92.1103448 L88.6068966,92.1103448 C89.7495547,92.1103448 90.6758621,93.0366522 90.6758621,94.1793103 L90.6758621,97.0758621 L63.3655172,97.0758621 L63.3655172,94.1793103 C63.3655172,93.0366522 64.2918247,92.1103448 65.4344828,92.1103448 L65.4344828,92.1103448 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M63.3655172,97.0758621 L90.6758621,97.0758621 L90.6758621,104.524138 C90.6758621,107.952112 87.8969398,110.731034 84.4689655,110.731034 L69.5724138,110.731034 C66.1444395,110.731034 63.3655172,107.952112 63.3655172,104.524138 L63.3655172,97.0758621 L63.3655172,97.0758621 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M98.1241379,35.1724138 L98.1241379,30.2068966 C98.1241379,18.5517839 88.6758023,9.10344828 77.0206897,9.10344828 C65.365577,9.10344828 55.9172414,18.5517839 55.9172414,30.2068966 L55.9172414,35.1724138 C53.8651583,35.1837203 52.2044099,36.8444687 52.1931034,38.8965517 L52.1931034,40.137931 C52.1931034,42.1947156 53.8604568,43.862069 55.9172414,43.862069 L56.2689655,43.862069 C58.0465552,53.9369234 66.8005645,61.2816045 77.0310345,61.2816045 C87.2615045,61.2816045 96.0155138,53.9369234 97.7931034,43.862069 L98.1241379,43.862069 C99.1135296,43.8676119 100.064003,43.4770287 100.763619,42.7774122 C101.463236,42.0777957 101.853819,41.1273227 101.848334,40.137931 L101.848334,38.8965517 C101.848334,37.9088489 101.455912,36.9615999 100.757501,36.2631885 C100.05909,35.5647772 99.1118407,35.1724138 98.1241379,35.1724138 L98.1241379,35.1724138 Z"
              class="stroke fill-white"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M91.9172414,43.7586207 C91.9172414,45.1298104 90.8056725,46.2413793 89.4344828,46.2413793 C88.063293,46.2413793 86.9517241,45.1298104 86.9517241,43.7586207 C86.9517241,42.387431 88.063293,41.2758621 89.4344828,41.2758621 C90.8056725,41.2758621 91.9172414,42.387431 91.9172414,43.7586207 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M67.0896552,43.7586207 C67.0896552,45.1298104 65.9780863,46.2413793 64.6068966,46.2413793 C63.2357068,46.2413793 62.1241379,45.1298104 62.1241379,43.7586207 C62.1241379,42.387431 63.2357068,41.2758621 64.6068966,41.2758621 C65.9780863,41.2758621 67.0896552,42.387431 67.0896552,43.7586207 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M70.8137931,48.7241379 C74.2896552,52.0344828 79.7517241,52.0344828 83.2275862,48.7241379"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M88.1931034,37.2413793 C87.6280914,36.0246286 86.430122,35.2259823 85.0896552,35.1724138 C83.7521962,35.2351908 82.5585622,36.0309467 81.9862069,37.2413793"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M72.0551724,37.2413793 C71.4901604,36.0246286 70.292191,35.2259823 68.9517241,35.1724138 C67.6142651,35.2351908 66.4206312,36.0309467 65.8482759,37.2413793"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M55.6689655,34.2206897 C58.979801,30.521378 60.8199865,25.7368957 60.8413793,20.7724138 C65.6186867,21.6293282 70.4735362,21.9761031 75.3241379,21.8068966 C80.859429,21.8742016 86.3920276,21.5284142 91.8758621,20.7724138 C91.8972549,25.7368957 93.7374404,30.521378 97.0482759,34.2206897 C102.373083,23.5763019 98.8015535,10.6295057 88.7724138,4.22068966 L88.7724138,9.39310345 C88.7724138,9.39310345 86.7034483,2.15172414 80.4965517,0.0827586207 L80.4965517,6.28965517 L77.3931034,2.15172414 C77.3931034,2.15172414 76.3586207,6.28965517 73.2551724,6.28965517 C70.1517241,6.28965517 47.3931034,11.462069 55.6689655,34.2206897 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M55.6689655,34.2206897 C58.979801,30.521378 60.8199865,25.7368957 60.8413793,20.7724138 C65.6186867,21.6293282 70.4735362,21.9761031 75.3241379,21.8068966 C80.859429,21.8742016 86.3920276,21.5284142 91.8758621,20.7724138 C91.8972549,25.7368957 93.7374404,30.521378 97.0482759,34.2206897 C102.373083,23.5763019 98.8015535,10.6295057 88.7724138,4.22068966 L88.7724138,9.39310345 C88.7724138,9.39310345 86.7034483,2.15172414 80.4965517,0.0827586207 L80.4965517,6.28965517 L77.3931034,2.15172414 C77.3931034,2.15172414 76.3586207,6.28965517 73.2551724,6.28965517 C70.1517241,6.28965517 47.3931034,11.462069 55.6689655,34.2206897 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <ellipse
              id="Oval"
              class="fill-extra-light"
              fill-rule="nonzero"
              cx="26.1241379"
              cy="131.462069"
              rx="20.6896552"
              ry="3.10344828" />
            <path
              id="Path"
              d="M7.08965517,88.8 L45.1586207,88.8 C46.3012788,88.8 47.2275862,89.7263074 47.2275862,90.8689655 L47.2275862,125.627586 C47.2275862,127.912902 45.3749714,129.765517 43.0896552,129.765517 L9.15862069,129.765517 C6.87330448,129.765517 5.02068966,127.912902 5.02068966,125.627586 L5.02068966,90.8689655 C5.02068966,89.7263074 5.94699707,88.8 7.08965517,88.8 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M7.08965517,88.8 L45.1586207,88.8 C46.3012788,88.8 47.2275862,89.7263074 47.2275862,90.8689655 L47.2275862,125.627586 C47.2275862,127.912902 45.3749714,129.765517 43.0896552,129.765517 L9.15862069,129.765517 C6.87330448,129.765517 5.02068966,127.912902 5.02068966,125.627586 L5.02068966,90.8689655 C5.02068966,89.7263074 5.94699707,88.8 7.08965517,88.8 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="5.02068966"
              y="98.7310345"
              width="42.2068966"
              height="7.44827586" />
            <path
              id="Path"
              d="M5.02068966,93.7655172 L2.53793103,93.7655172 C1.88134917,93.7655172 1.25195632,94.027728 0.789629452,94.49394 C0.327302579,94.960152 0.0703445739,95.5917172 0.075862069,96.2482759 C-0.191425007,105.733202 4.71603263,114.614295 12.888565,119.4356 C21.0610973,124.256905 31.2078682,124.256905 39.3804005,119.4356 C47.5529329,114.614295 52.4603905,105.733202 52.1931034,96.2482759 C52.1986209,95.5917172 51.9416629,94.960152 51.4793361,94.49394 C51.0170092,94.027728 50.3876163,93.7655172 49.7310345,93.7655172 L47.2275862,93.7655172"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M34.2965517,123.62069 C28.9612459,125.189755 23.28703,125.189755 17.9517241,123.62069 C16.6438262,123.213293 15.9062525,121.830343 16.2965517,120.517241 C16.4830468,119.887074 16.9137373,119.357619 17.4927433,119.046743 C18.0717493,118.735867 18.7510105,118.669375 19.3793103,118.862069 C23.7828874,120.155229 28.4653885,120.155229 32.8689655,118.862069 C33.7190113,118.607055 34.6405341,118.824907 35.2864054,119.433561 C35.9322766,120.042215 36.2043731,120.949203 36.0001985,121.812872 C35.796024,122.67654 35.1465975,123.365676 34.2965517,123.62069 Z"
              class="stroke fill-light"
              stroke-width="2.06896552"
              fill-rule="nonzero"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M9.9862069,88.8 L9.9862069,108.041379 C9.9862069,109.755366 11.375668,111.144828 13.0896552,111.144828 C14.8036423,111.144828 16.1931034,109.755366 16.1931034,108.041379 L16.1931034,101.834483 C16.1931034,100.120496 17.5825646,98.7310345 19.2965517,98.7310345 C21.0105389,98.7310345 22.4,100.120496 22.4,101.834483 L22.4,102.455172 C22.4,104.511957 24.0673533,106.17931 26.1241379,106.17931 C28.1809225,106.17931 29.8482759,104.511957 29.8482759,102.455172 L29.8482759,88.8 L9.9862069,88.8 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M9.9862069,88.8 L9.9862069,108.041379 C9.9862069,109.755366 11.375668,111.144828 13.0896552,111.144828 C14.8036423,111.144828 16.1931034,109.755366 16.1931034,108.041379 L16.1931034,101.834483 C16.1931034,100.120496 17.5825646,98.7310345 19.2965517,98.7310345 C21.0105389,98.7310345 22.4,100.120496 22.4,101.834483 L22.4,102.455172 C22.4,104.511957 24.0673533,106.17931 26.1241379,106.17931 C28.1809225,106.17931 29.8482759,104.511957 29.8482759,102.455172 L29.8482759,88.8 L9.9862069,88.8 Z"
              class="stroke"
              stroke-width="2.06896552"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
